var _clipPath;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNeonatology(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 68 68",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "neonatology"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_52",
    d: "M68,3l0,62c0,1.656 -1.344,3 -3,3l-62,0c-1.656,0 -3,-1.344 -3,-3l0,-62c0,-1.656 1.344,-3 3,-3l62,0c1.656,0 3,1.344 3,3Z",
    style: {
      fill: "#fff",
      fillOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_36"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35"
  }, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.687,
    y: 10.819,
    width: 62.625,
    height: 46.18
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    d: "M50.015,10.819c-8.039,0 -13.938,5.665 -19.644,11.145c-5.09,4.888 -9.9,9.506 -15.691,9.506c-5.508,0 -10.045,-5.375 -9.277,-9.95c0.811,-4.826 5.892,-8.865 12.489,-8.865c4.7,0 8.465,1.307 14.576,5.973c-3.181,-3.725 -9.359,-7.809 -14.575,-7.809c-9.756,0 -15.206,6.539 -15.206,15.488c0,15.774 25.134,29.045 31.267,30.692c0,0 -28.957,-15.156 -29.368,-30.578c-0.004,-0.746 0.063,-1.49 0.2,-2.223c1.634,7.221 7.72,10.028 13.961,8.052c4.667,-1.478 8.83,-4.921 12.9,-8.962c5.349,-5.319 11.068,-10.633 18.368,-10.633c7.591,0 16.769,8.568 13.526,19.348c1.213,-1.603 1.838,-3.575 1.771,-5.584c0.001,-0.079 0.002,-0.159 0.002,-0.238c-0,-8.404 -6.896,-15.327 -15.299,-15.362",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    d: "M34.071,37.516c0.472,-0.968 1.467,-1.577 2.543,-1.558c1.285,0.031 2.408,0.899 2.762,2.134c0.47,1.287 0.094,4.826 -1.027,5.829c0.564,-1.731 0.543,-3.6 -0.06,-5.317c-0.228,-0.714 -0.887,-1.209 -1.637,-1.229c-0.698,0.014 -1.322,0.449 -1.575,1.1c-1.385,3.122 -1.157,10.608 9.872,7.829c-4.7,2.343 -8.868,1.275 -10.183,-0.732c-1.315,-2.007 -2.125,-5.435 -0.7,-8.058",
    style: {
      fill: "#6dc073",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    d: "M30.572,36.355c-5.545,-1.1 -7.933,7.5 -8.07,8.272c-3.588,0.993 -1.658,6.359 3.24,3.366c0.639,-0.469 1.197,-1.041 1.65,-1.691l0.018,-1.75c-0.669,1.082 -1.559,2.011 -2.611,2.726c-0.875,0.443 -2.333,0.845 -2.943,0.06c-0.533,-0.688 0.628,-1.889 1.618,-2.158c0.143,-0.8 2.389,-8.161 6.435,-7.519c2.811,0.445 4.812,4.689 2.877,10.615c3.195,-3.969 1.839,-11.118 -2.214,-11.919",
    style: {
      fill: "#6dc073",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    d: "M61.105,24.795c-1.664,-2.534 -4.28,-4.294 -7.254,-4.882c-6.218,-1.242 -11.934,3.286 -14.228,8.042c-4.108,3.272 -3.755,13.4 7.588,14.763c-11.982,-4 -8.807,-12.418 -6.37,-13.962l0.085,-0.184c1.991,-4.3 7.094,-8.272 12.627,-7.166c2.576,0.51 4.842,2.036 6.283,4.231c1.479,2.218 2.004,4.94 1.456,7.548c-0.668,3.228 -3.848,7.177 -7.271,7.626c2.424,1.457 -0.219,3.96 -2.557,1.317c-1.048,0.236 -2.6,2.142 -3.957,4.129c-4.532,6.635 -12.884,11.4 -18.275,4c-2.07,-2.84 -1.728,-5.77 0.005,-8.438c0.213,-0.327 -0.165,-0.624 -0.6,-0.149c-2.484,2.692 -2.618,6.842 -0.311,9.688c6.286,7.684 15.7,2.264 19.886,-4.665c1.445,-2.393 2.542,-3.463 3.545,-3.31c3.151,2.484 5.723,-0.556 3.99,-2.168c3.753,-1.571 6.32,-4.242 7.04,-7.723c0.63,-3.006 0.025,-6.144 -1.678,-8.7",
    style: {
      fill: "#6dc073",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    d: "M42.375,29.683c0.231,1.28 1.139,2.34 2.368,2.766c-0.161,0.488 -1.521,0.341 -2.344,-0.508c-1.215,-1.256 -0.415,-2.243 -0.024,-2.258",
    style: {
      fill: "#6dc073",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    d: "M50.355,37.622c-1.284,-0.209 -2.36,-1.097 -2.808,-2.318c-0.485,0.168 -0.314,1.526 0.55,2.334c1.277,1.193 2.25,0.376 2.258,-0.016",
    style: {
      fill: "#6dc073",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    d: "M44.401,37.624c-0.866,-0.237 -1.556,-0.895 -1.834,-1.749c-0.202,0.229 -0.313,0.524 -0.313,0.829c-0,0.366 0.161,0.715 0.44,0.953c0.217,0.231 0.521,0.363 0.838,0.363c0.333,-0 0.651,-0.145 0.869,-0.397",
    style: {
      fill: "#6dc073",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    d: "M55.103,26.174c0.8,0.4 1.054,0.934 0.9,1.532c-0.292,0.806 -1.191,1.233 -2,0.95c-1.12,-0.292 -1.802,-1.454 -1.511,-2.574c0.418,-1.6 2.278,-3.295 5.619,-1.6c-3.246,-2.405 -5.452,-0.91 -6.373,1.216c-0.148,0.357 -0.223,0.739 -0.223,1.125c-0,1.326 0.897,2.496 2.178,2.84c2.187,0.721 4.117,-1.594 3.123,-3.068c-0.92,-1.366 -2.507,-0.823 -1.712,-0.422",
    style: {
      fill: "#6dc073",
      fillRule: "nonzero"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeonatology);
export default __webpack_public_path__ + "static/media/neonatology.a6be2ea1993d3eba68f19e8a871c76d8.svg";
export { ForwardRef as ReactComponent };